import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

const { createAsyncThunk } = require('@reduxjs/toolkit');

export const getPolicy = createAsyncThunk(
  'get/policy',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(URLS.POLICY.GET_POLICY_CONTENT);
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
